export const calculateProgress = (ca: number, caObjectif: number) => {
  const objective = Math.floor((ca / caObjectif) * 100);
  let color: string;
  if (objective < 25) {
    color = '#EC3207';
  } else if (objective < 40) {
    color = '#FF8E0F';
  } else if (objective < 60) {
    color = '#EBB209';
  } else if (objective < 75) {
    color = '#16AD08';
  } else {
    color = '#149606';
  }
  return objective >= 100 ? { objective: 100, color } : { objective, color };
};
